import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner/Banner";
import BestSellers from "../../components/home/BestSellers/BestSellers";
import NewArrivals from "../../components/home/NewArrivals/NewArrivals";
import WhyShopWithUs from "../../components/WhyShopWithUs/WhyShopWithUs";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import toast from "react-hot-toast";
import ProductShowcase from "../../components/home/ProductShowcase/ProductShowcase";
import InstagramFeed from "../../components/home/InstagramFeed/Instafeed";
import LogoMarquee from "../../components/home/LogoMarquee/LogoMarquee";

const Home = () => {
  const [homeProducts, setHomeProducts] = useState({
    topBuyers: [],
    newArrived: [],
    featured: [],
    bestSellers: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchHomeProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await ApiService({
        method: "GET",
        endpoint: apiPaths.homeProducts, // "products/home"
      });

      if (response.success) {
        setHomeProducts({
          topBuyers: response.data.bestsellers || [], // Updated to match backend response
          newArrived: response.data.newArrivals || [], // Updated to match backend response
          featured: response.data.featured || [],
          bestSellers: response.data.bestsellers || [], // Updated to match backend response
        });
      } else {
        setError("Failed to fetch home products");
        toast.error("Failed to load products");
      }
    } catch (err) {
      console.error("Error fetching home products:", err);
      setError("Failed to fetch home products");

      // Show user-friendly error message
      const errorMessage =
        err?.response?.data?.message || "Failed to load products";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHomeProducts();
  }, []);

  return (
    <div className="w-full mx-auto">
      <Banner />
      <div className="mx-auto">
        <ProductShowcase />
        {/* New Arrivals Section */}
        <NewArrivals products={homeProducts.newArrived} isLoading={isLoading} />
        {/* <LogoMarquee /> */}
        {/* Best Sellers Section */}
        <BestSellers products={homeProducts.topBuyers} isLoading={isLoading} />
        <InstagramFeed />
        <WhyShopWithUs />
      </div>
    </div>
  );
};

export default Home;
